<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="tw-fill-black dark:tw-fill-white" viewBox="0 0 8 14"><path d="M2.46 7.71a1 1 0 0 1 0-1.42l4.59-4.58A1 1 0 1 0 5.64.3l-4.6 4.6a3 3 0 0 0 0 4.23l4.6 4.6a1 1 0 0 0 1.4-1.43z"/></svg>
</template>
